import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'

import { LoginForm, safeRedirect } from '@/features/auth'
import { meQuery } from '@/lib/api/queries/auth'
import { optional, z } from '@/lib/utils/search-params'

const loginSearch = z.object({
  redirect: optional(z.string()),
  reason: optional(z.enum(['expired', 'signed-out', 'locked'])),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearch,
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.ensureQueryData(meQuery).catch(() => null)
    if (me) throw redirect({ href: safeRedirect(search.redirect), replace: true })
  },
  component: LoginRoute,
})

function LoginRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <LoginForm
      reason={search.reason}
      onSignedIn={() => navigate({ href: safeRedirect(search.redirect), replace: true })}
    />
  )
}
